import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'dcc-close-button',
  template: `
    <button (click)="onClick()">
      <i class="lx-icon lx-close-x"></i>
    </button>
  `,
  styleUrls: ['close-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseButtonComponent {
  @Output() buttonClick: EventEmitter<void> = new EventEmitter();

  onClick() {
    this.buttonClick.emit();
  }
}
